import { render, staticRenderFns } from "./Editar-Post.vue?vue&type=template&id=3da4548b&"
import script from "./Editar-Post.vue?vue&type=script&lang=js&"
export * from "./Editar-Post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Editar-Post.vue"
export default component.exports